import {gql} from 'apollo-angular';


export const GET_ORDER_COUNT = gql`
    query GetOrderList($options: OrderListOptions) {
        activeCustomer {
            orders(options: $options) {
                totalItems
            }
        }
    }
`;
